module.exports = __webpack_public_path__ + "img/blueprints2.7857b678.png";